export class Internshipperiod {
  public id?: string;
  public orgunitId?: number;
  public identifier?: string;
  public startCalendarWeek?: number;
  public durationInWeeks?: number;
}
